<template>
  <!-- 首页 -->
  <div class="pagebox">
    <!-- top -->
    <CommonTopItems></CommonTopItems>
    <!-- 页头 -->
    <CommonHeaderItems :activeIndex="activeIndex"></CommonHeaderItems>
    <!-- banner图部分 -->
    <IndexBannerItems></IndexBannerItems>
    <!-- 问卷调查图片 -->
    <img class="wjdc-img" :src="wxdjImgUrl" alt="">
    <!-- 检索条件 -->
    <div class="index-searchbox">
      <div class="searchbox-searchcon">
        <el-tabs class="searchcon-searchtabs" type="card" @tab-click="searchconToggle">
          <!-- 专利检索 -->
          <el-tab-pane label="专利搜索">
            <IndexPatentSearchItems ref="patentInpuVal"></IndexPatentSearchItems>
          </el-tab-pane>
          <!-- 商标检索 -->
          <el-tab-pane label="商标搜索">
            <IndexBrandSearchItems ref="brandInputVal"></IndexBrandSearchItems>
          </el-tab-pane>
        </el-tabs>
        <div class="searchcon-ahrefbox">
          <div class="ahrefbox-alink" @click="jumpExternalLinksHandle('https://sbj.cnipa.gov.cn/sbj/wssq/')">商标在线申请</div>
          <div class="ahrefbox-alink" @click="jumpExternalLinksHandle('https://www.nmgipup.cn/')">专利预审</div>
        </div>
      </div>
    </div>
    <!-- 数据图表看板 -->
    <div class="index-databoard">
      <div class="databoard-boardcon">
        <div class="boardcon-boardtitle">包头市知识产权数据看板</div>
        <div class="boardcon-boardmain">
          <div class="bmain-btoppart bmain-bgraphpart">
            <div class="btoppart-left">
              <div class="btoppart-left">
                <!--专利保护状态-饼图-->
                <div class="bgraphpart-patprochart" v-loading="patProLoading"
                  element-loading-background="rgba(25, 38, 55, 0)">
                  <IndexPatProPieChart :echartDatas="patProChartDatas"></IndexPatProPieChart>
                </div>
                <!--国内申请人排名-堆积柱状图-->
                <div class="bgraphpart-apchart" v-loading="apLoading" element-loading-background="rgba(25, 38, 55, 0)">
                  <IndexDomesticApBarChart :echartDatas="apChartDatas"></IndexDomesticApBarChart>
                </div>
              </div>
            </div>
            <div class="btoppart-center">
              <div class="bgraphpart-pattypenum" v-loading="basicLoading"
                element-loading-background="rgba(25, 38, 55, 0)">
                <span class="pattypenum-pattypeitem">
                  <span class="pattypeitem-pcount pcount-patent">{{ basicPnum.toLocaleString() }}</span>
                  <span class="pattypeitem-pname">专利总量</span>
                </span>
                <span class="pattypenum-pattypeitem">
                  <span class="pattypeitem-pcount">{{ basicPatInvent.toLocaleString() }}</span>
                  <span class="pattypeitem-pname">发明专利</span>
                </span>
                <span class="pattypenum-pattypeitem">
                  <span class="pattypeitem-pcount">{{ basicPatForce.toLocaleString() }}</span>
                  <span class="pattypeitem-pname">有效专利</span>
                </span>
                <span class="pattypenum-pattypeitem">
                  <span class="pattypeitem-pcount">{{ basicPatChina.toLocaleString() }}</span>
                  <span class="pattypeitem-pname">中国专利</span>
                </span>
                <span class="pattypenum-pattypeitem">
                  <span class="pattypeitem-pcount">{{ basicPatOverseas.toLocaleString() }}</span>
                  <span class="pattypeitem-pname">国内出海专利</span>
                </span>
              </div>
              <div class="bgraphpart-pnumchart" v-loading="pnumLoading" element-loading-background="rgba(25, 38, 55, 0)">
                <IndexCityApMapChart :echartDatas="pnumChartDatas"></IndexCityApMapChart><!-- 国内各城市申请量-地图 -->
              </div>
            </div>
            <div class="btoppart-right">
              <div class="bgraphpart-patquality" v-loading="patQualityLoading"
                element-loading-background="rgba(25, 38, 55, 0)">
                <IndexPatqualityBarChart :echartDatas="patQualityChartDatas"></IndexPatqualityBarChart>
                <!--专利质量指数-环形柱状图-->
              </div>
              <div class="bgraphpart-transferor" v-loading="transferorLoading"
                element-loading-background="rgba(25, 38, 55, 0)">
                <IndexTransferorBarChart :echartDatas="transferorChartDatas"></IndexTransferorBarChart>
                <!--国内出让人排名-柱状图-->
              </div>
            </div>
          </div>
          <div class="bmain-bbottompart bmain-bgraphpart">
            <div class="bbottompart-trendchart" v-loading="trendLoading" element-loading-background="rgba(25, 38, 55, 0)">
              <IndexTrendLineChart :echartDatas="trendChartDatas"></IndexTrendLineChart>
              <!--申请和授权趋势-折线图-->
            </div>
            <div class="bbottompart-lifechart" v-loading="lifeLoading" element-loading-background="rgba(25, 38, 55, 0)">
              <IndexLifeBarChart :echartDatas="lifeChartDatas"></IndexLifeBarChart>
              <!--专利寿命分布-柱状图-->
            </div>
            <div class="bbottompart-dynamicchart" v-loading="dynamicLoading"
              element-loading-background="rgba(25, 38, 55, 0)">
              <IndexDynamicLineChart :echartDatas="dynamicChartDatas"></IndexDynamicLineChart>
              <!--近期申请和授权动态-折线图-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 指引指南说明 -->
    <IndexGuideItems></IndexGuideItems>
    <!-- 页尾 -->
    <CommonFooterItems></CommonFooterItems>
  </div>
</template>

<script>
import citysData from '@/assets/js/region.js'
// @ is an alias to /src // 引入自定义组件
import CommonTopItems from '@/components/CommonTopItems.vue' // top
import CommonHeaderItems from '@/components/CommonHeaderItems.vue' // 页头
import CommonFooterItems from '@/components/CommonFooterItems.vue' // 页尾
import IndexBannerItems from '@/components/index/IndexBannerItems.vue' // banner轮播
import IndexGuideItems from '@/components/index/IndexGuideItems.vue' // 第五部分-指引说明
import IndexPatentSearchItems from '@/components/index/IndexPatentSearchItems.vue' // 第二部分-检索-专利
import IndexBrandSearchItems from '@/components/index/IndexBrandSearchItems.vue' // 第二部分-检索-商标
import IndexPatProPieChart from '@/components/index/IndexPatProPieChart.vue' // 专利保护状态-饼图
import IndexDomesticApBarChart from '@/components/index/IndexDomesticApBarChart.vue' // 国内申请人排名-堆积柱状图
import IndexCityApMapChart from '@/components/index/IndexCityApMapChart.vue' // 国内各城市申请量-地图
import IndexPatqualityBarChart from '@/components/index/IndexPatqualityBarChart.vue' // 专利质量指数-环形柱状图
import IndexTransferorBarChart from '@/components/index/IndexTransferorBarChart.vue' // 国内出让人排名-柱状图
import IndexTrendLineChart from '@/components/index/IndexTrendLineChart.vue' // 申请和授权趋势-折线图、近期申请和授权动态-折线图
import IndexLifeBarChart from '@/components/index/IndexLifeBarChart.vue' // 专利寿命分布-柱状图
import IndexDynamicLineChart from '@/components/index/IndexDynamicLineChart.vue' // 近期申请和授权动态-折线图
export default {
  data () {
    return {
      patentQueryValue: '', // 专利input值
      activeIndex: '1', // 导航
      listActiveName: '1', // tab榜单列表切换
      database: '', // 接口所需字段db
      dataDist: 'apcp=cn1502', // 接口所需字段q - 所选地区城市代码-包头市
      cityApDist: 'apcp=cn', // 国内各城市申请量-地图
      // 基本信息
      basicPnum: 0, // 专利总量
      basicPatInvent: 0, // 发明专利
      basicPatForce: 0, // 有效专利
      basicPatChina: 0, // 中国专利
      basicPatOverseas: 0, // 国内出海专利
      basicLoading: false,
      patProLoading: false,
      pnumLoading: false,
      patQualityLoading: false,
      transferorLoading: false,
      trendLoading: false,
      lifeLoading: false,
      dynamicLoading: false,
      patProChartDatas: [], // 专利保护状态-数据
      queryAp: 'dist=cn1502 and cpt=企事业单位', // 国内申请人排名-所需的条件
      apLoading: true,
      apChartDatas: [], // 国内申请人排名-数据
      pnumChartDatas: [
        // {
        //   name: '深圳', value: 112
        // }
      ], // 国内各城市申请量-地图
      patQualityChartDatas: {}, // 专利质量指数-环形柱状图
      transferorChartDatas: [],
      trendChartDatas: { // 申请和授权趋势-折线图
        ad_year: [],
        gd_year: []
      },
      lifeChartDatas: [], // 专利寿命分布-柱状图
      dynamicChartDatas: {
        ad_month: [],
        gd_month: []
      }, // 近期申请和授权动态-折线图
      // 问卷调查图片-左侧
      wxdjImgUrl: require('@/assets/images/wjdc.jpg')
    }
  },
  components: {
    CommonTopItems,
    CommonHeaderItems,
    IndexBannerItems,
    IndexGuideItems,
    CommonFooterItems,
    IndexPatentSearchItems,
    IndexBrandSearchItems,
    IndexPatProPieChart,
    IndexDomesticApBarChart,
    IndexCityApMapChart,
    IndexPatqualityBarChart,
    IndexTransferorBarChart,
    IndexTrendLineChart,
    IndexLifeBarChart,
    IndexDynamicLineChart
  },
  created () {
    this.getOrgListDatas()
  },
  methods: {
    // 跳转外部链接
    jumpExternalLinksHandle (href) {
      window.open(href, '_blank')
    },
    searchconToggle () {
      // tab切换-(清空所填条件)-专利检索/商标检索
      this.$refs.patentInpuVal.patentQueryValue = ''
      this.$refs.brandInputVal.brandQueryValue = ''
    },
    getOrgListDatas () {
      let _this = this
      // 基本信息
      _this.basicLoading = true
      // 专利保护状态
      _this.patProLoading = true
      // 国内申请人排名-堆积柱状图
      _this.apLoading = true
      // 包头市各区申请量-地图
      _this.pnumLoading = true
      // 专利质量指数-环形柱状图
      _this.patQualityLoading = true
      // 国内出让人排名-柱状图
      _this.transferorLoading = true
      // 申请和授权趋势-折线图
      _this.trendLoading = true
      // 专利寿命分布-柱状图
      _this.lifeLoading = true
      // 近期申请和授权动态-折线图
      _this.dynamicLoading = true


      let month = new Date().getMonth()
      let year = new Date().getFullYear()
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month < 10) {
        month = '0' + month
      }
      let num = year.toString() + month.toString()
      let qsData = _this.$qs.stringify({
        date_type: 4,
        num: num
      })
      _this.$axios({
        url: '/network_supervision/overview',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qsData
      }).then(res => {
        console.log(res.data)
        if (res.data.code == 200) {
          let { data } = res.data
          _this.postBasicDatas(data.total_correlation)
          _this.postPatProDatas(data.patent_protection_status)
          _this.postApDatas(data.ap_sort)
          _this.postPnumDatas(data.atlas)
          _this.postpatqualityDatas(data.quality)
          _this.postTransferorDatas(data.cpa1id)
          _this.postTrendDatas(data.application_authorization_trend)
          _this.postLifeDatas(data.prl)
          _this.postDynamicDatas(data.application_authorization_dynamic)
        } else {
          // 基本信息
          _this.basicLoading = false
          // 专利保护状态
          _this.patProLoading = false
          // 国内申请人排名-堆积柱状图
          _this.apLoading = false
          // 包头市各区申请量-地图
          _this.pnumLoading = false
          // 专利质量指数-环形柱状图
          _this.patQualityLoading = false
          // 国内出让人排名-柱状图
          _this.transferorLoading = false
          // 申请和授权趋势-折线图
          _this.trendLoading = false
          // 专利寿命分布-柱状图
          _this.lifeLoading = false
          // 近期申请和授权动态-折线图
          _this.dynamicLoading = false

          _this.basicPnum = 0 // 专利总量
          _this.basicPatInvent = 0 // 发明专利
          _this.basicPatForce = 0 // 有效专利
          _this.basicPatChina = 0 // 中国专利
          _this.basicPatOverseas = 0 // 国内出海专利
          _this.patProChartDatas = [] // 专利保护状态-数据
          _this.apChartDatas = [] // 国内申请人排名-数据
          _this.pnumChartDatas = [] // 国内各城市申请量-地图
          _this.patQualityChartDatas = {} // 专利质量指数-环形柱状图
          _this.transferorChartDatas = []
          _this.trendChartDatas = {
            ad_year: [],
            gd_year: []
          } // 申请和授权趋势-折线图
          _this.dynamicChartDatas = {
            ad_month: [],
            gd_month: []
          } // 近期申请和授权动态-折线图
          _this.lifeChartDatas = [] // 专利寿命分布-柱状图
        }
      })
    },
    // 获取看板数据接口---------------------------------------

    postBasicDatas (data) {
      // 基本信息
      console.log('基本信息')
      this.basicLoading = false
      data.forEach(item => {
        if (item.name.indexOf('专利总量') >= 0) {
          this.basicPnum = item.count
        }
        if (item.name.indexOf('发明专利') >= 0) {
          this.basicPatInvent = item.count
        }
        if (item.name.indexOf('有效专利') >= 0) {
          this.basicPatForce = item.count
        }
        if (item.name.indexOf('中国专利') >= 0) {
          this.basicPatChina = item.count
        }
        if (item.name.indexOf('国内出海专利') >= 0) {
          this.basicPatOverseas = item.count
        }
      })
    },
    postPatProDatas (data) {
      // 专利保护状态-饼图
      let _this = this
      _this.patProLoading = false
      _this.patProChartDatas = data
    },
    postApDatas (data) {
      // 国内申请人排名-堆积柱状图
      let _this = this
      _this.apLoading = false
      _this.apChartDatas = data
    },
    postPnumDatas (data) {
      // 包头市各区申请量-地图
      let _this = this
      _this.pnumLoading = false
      _this.pnumChartDatas = data.apcp
    },
    postpatqualityDatas (data) {
      // 专利质量指数-环形柱状图
      let _this = this
      _this.patQualityLoading = false
      _this.patQualityChartDatas = data
    },
    postTransferorDatas (data) {
      // 国内出让人排名-柱状图
      let _this = this
      _this.transferorLoading = false
      _this.transferorChartDatas = data
    },
    postTrendDatas (data) {
      // 申请和授权趋势-折线图
      let _this = this
      _this.trendLoading = false
      _this.trendChartDatas = data
    },
    postLifeDatas (data) {
      // 专利寿命分布-柱状图
      let _this = this
      _this.lifeLoading = false
      _this.lifeChartDatas = data
    },
    postDynamicDatas (data) {
      // 近期申请和授权动态-折线图
      let _this = this
      _this.dynamicLoading = false
      _this.dynamicChartDatas = data
    }
  }
}
</script>

<style>
.pagebox {
  margin: 0 auto;
  width: 100%;
  min-width: 1440px;
  box-sizing: border-box;
}

/* 检索条件 */
.index-searchbox {
  margin-top: 30px;
}

.searchbox-searchcon {
  position: relative;
  margin: 0 auto;
  width: 1058px;
}

.el-tabs--card>.el-tabs__header {
  margin: 0;
  border: none;
}

.searchcon-searchtabs .el-tabs__content {
  overflow: initial;
}

.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

.searchcon-searchtabs .el-tabs__item {
  display: block;
  float: left;
  width: 130px;
  height: 30px;
  line-height: 28px;
  background: #999999;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
}

.searchcon-searchtabs .el-tabs__item:first-child {
  margin-right: 20px;
}

.el-tabs__item,
.el-tabs__item:hover {
  color: #ffffff;
}

.index-searchbox .el-tabs__item.is-active {
  background: #d42a2a;
  color: #ffffff;
}

/* 检索部分 */
.search-commonbox {
  text-align: left;
}

/* 单选框 */
.common-radiobox {
  margin: 20px 0 10px;
}

.common-radiobox .el-radio-button__inner {
  display: block;
  float: left;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: none !important;
  border-radius: 0;
  box-sizing: border-box;
  color: #333333;
  cursor: pointer;
}

.common-radiobox .el-radio-button__inner:hover {
  color: #333333;
}

.common-radiobox .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: none;
  box-shadow: none;
  color: #333333;
  font-weight: 700;
}

/* 搜索框 */
.common-querybox {
  position: relative;
  margin-bottom: 10px;
  height: 40px;
}

.comquery-inputbox {
  position: relative;
  float: left;
  width: 1000px;
}

.inputbox-input {
  display: block;
}

.inputbox-input .el-input__inner {
  display: block;
  margin: 0;
  padding: 0 52px 0 10px;
  width: 1000px;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(121, 121, 121, 1);
  border-radius: 0;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  color: #333333;
  font-size: 14px;
}

.inputbox-input .el-input__inner:focus {
  border: 1px solid #050162;
}

.inputbox-btn {
  position: absolute;
  top: 1px;
  right: 0px;
}

.comquery-inputbox .el-button {
  padding: 0px 10px;
  height: 38px;
  line-height: 38px;
  border: none;
  background: none;
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  box-sizing: border-box;
  outline: none;
  color: #050162;
  font-weight: 700;
  font-size: 16px;
}

.common-querybox .comquery-advanced {
  position: absolute;
  top: 0;
  right: 0px;
  display: block;
  line-height: 42px;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}

/* 复选框 */
.common-comcheckbox {
  margin-bottom: 20px;
  padding-left: 5px;
  text-align: left;
  box-sizing: border-box;
  font-size: 12px;
}

.common-comcheckbox:after {
  display: block;
  content: '';
  clear: both;
}

.comcheckbox-group {
  display: block;
  float: left;
  margin: 0 10px 0 0;
}

.common-comcheckbox .el-checkbox {
  display: block;
  float: left;
  margin-right: 10px;
}

.comcheckbox-group .el-checkbox__label {
  padding-left: 6px;
  color: #333333 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #d42a2a;
  border-color: #d42a2a;
}

/* 更新时间说明 */
.common-inforcon {
  margin-left: 5px;
}

.inforcon-inforp {
  color: #d42a2a;
  font-weight: 700;
  font-size: 12px;
}

/* 跳转外部链接 */
.searchcon-ahrefbox {
  position: absolute;
  top: 0;
  left: 300px;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}

.ahrefbox-alink {
  margin-right: 20px;
  width: 130px;
  background: #4e6ef2;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

.ahrefbox-alink:last-child {
  margin-right: 0;
}

/* 数据图表看板 */
.index-databoard {
  margin: 0 auto;
  width: 100%;
  background: #192637;
}

.databoard-boardcon {
  position: relative;
  margin: 30px auto 0;
  padding-top: 75px;
  width: 1440px;
}

.boardcon-boardtitle {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -220px;
  width: 440px;
  height: 50px;
  line-height: 50px;
  background: #c30d23;
  color: #ffffff;
  font-size: 20px;
}

/* 看板-图表 */
.boardcon-boardgraph {}

.boardcon-boardmain {}

/* top-部分 */
.bmain-btoppart {
  display: flex;
  justify-content: flex-start;
}

/* top-左侧图表 */
.btoppart-left {
  display: block;
  /* float: left; */
  width: 357px;
}

.bgraphpart-patprochart {
  width: 357px;
  height: 325px;
}

.bgraphpart-apchart {
  margin-top: 52px;
  width: 357px;
  height: 452px;
}

/* top-中间图表 */
.btoppart-center {
  flex: 1;
  display: block;
  /* float: left; */
  width: 726px;
}

.bgraphpart-pattypenum {
  display: flex;
  justify-content: space-between;
  height: 64px;
}

.pattypenum-pattypeitem {}

.pattypeitem-pcount {
  display: block;
  /* color: #ffef00; */
  color: #fff;
  font-size: 24px;
}

.pcount-patent {
  color: #ffef00;
}

.pattypeitem-pname {
  display: block;
  color: #6fa0e1;
  font-size: 18px;
}

.bgraphpart-pnumchart {
  margin: 57px 38px 0;
  width: 650px;
  height: 650px;
}

/* top-右侧图表 */
.btoppart-right {
  display: block;
  /* float: left; */
  width: 357px;
}

.bgraphpart-patquality {
  width: 357px;
  height: 325px;
}

.bgraphpart-transferor {
  margin-top: 52px;
  width: 357px;
  height: 452px;
}

/* bottom-部分 */
.bmain-bbottompart {
  margin-top: 52px;
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  height: 325px;
}

.bbottompart-trendchart {
  width: 454px;
  height: 325px;
}

.bbottompart-lifechart {
  padding: 0 19px;
  width: 532px;
  height: 325px;
}

.bbottompart-dynamicchart {
  width: 454px;
  height: 325px;
}

/* ----------------------------------- */
/* 榜单列表 */
.index-bangdanbox {
  position: relative;
  margin-top: 30px;
  width: 100%;
  box-sizing: border-box;
}

.bangdanbox-line {
  position: absolute;
  top: 38px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #817fb0;
}

.bangdancon-listtabsbox {
  width: 100%;
  box-sizing: border-box;
}

.bangdancon-listtabs {
  margin: 0 auto;
  width: 1058px;
  /* width: 100%;
    height: 40px;
    border-bottom: 2px solid #817fb0;
    box-sizing: border-box; */
}

.index-bangdanbox .el-tabs--card>.el-tabs__header .el-tabs__item {
  position: relative;
  display: block;
  float: left;
  width: 211px;
  height: 38px;
  line-height: 38px;
  border-left: none;
  box-sizing: border-box;
  text-align: center;
  color: #777777;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
}

.index-bangdanbox .el-tabs--card>.el-tabs__header .is-active {
  color: #050162;
}

.index-bangdanbox .el-tabs--card>.el-tabs__header .is-active::after {
  position: absolute;
  content: '';
  left: 50%;
  bottom: -1px;
  margin-left: -20px;
  width: 40px;
  height: 4px;
  background: #050162;
}

/* 查看更多 */
.bangdancon-listmore {
  display: block;
  margin: 20px auto 0;
  width: 1058px;
  text-align: right;
  color: rgb(5, 1, 98);
  cursor: pointer;
}

a.bangdancon-listmore:link,
a.bangdancon-listmore:visited {
  color: rgb(5, 1, 98);
}

.listmore-gengguoicon {
  transform: rotate(90deg);
}

/* 商标检索-输入框-申请人地址-弹框 */
.bretrieve-brsite {
  display: none;
  position: absolute;
  bottom: -6px;
  left: 50%;
  margin-left: -375px;
  width: 750px;
  height: 288px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(180, 180, 180, 0.4);
  box-sizing: border-box;
  z-index: 10;
}

.popup-brandaddress .el-dialog {
  width: 750px;
}

.popup-brandaddress .el-dialog .el-dialog__header {
  display: none;
}

.popup-brandaddress .el-dialog .el-dialog__body {
  padding: 0;
}

.brsite-brlocate {
  height: 230px;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
}

.brlocate-bchoose {
  float: left;
  padding: 25px 0 0 10px;
  width: 250px;
  height: 229px;
  box-sizing: border-box;
  overflow: hidden;
}

.bchoose-bcoption {
  display: block;
  float: left;
  margin: 0 3px 8px 0;
  padding: 3px 3px;
  cursor: pointer;
}

.bcprovince-bsid {
  display: none;
}

.bcprovince-bctxt {
  display: block;
}

.bchoose-bcoption:hover {
  background: #f44d4d;
  border-radius: 3px;
  color: #fff;
}

.bchoose-bcoption-atv {
  background: #f44d4d;
  border-radius: 3px;
  color: #fff;
}

.brlocate-bcenter {
  background: #eee;
}

.bpre-nohave {
  line-height: 180px;
  text-align: center;
  color: #a9a9a9;
}

.brsite-brelect {
  padding-left: 15px;
  height: 58px;
  box-sizing: border-box;
}

.brelect-bresult {
  display: block;
  float: left;
  margin-right: 10px;
  line-height: 58px;
  color: #f44d4d;
}

.brelect-bresinp {
  margin-top: 13px;
  /* padding-left: 15px; */
  padding: 0;
  width: 380px;
  height: 32px;
  /* border: 1px solid #3184d9; */
  box-sizing: border-box;
}

.brelect-bresinp .el-input__inner {
  height: 32px;
  line-height: 32px;
  border: 1px solid #3184d9;
  border-radius: 0;
}

.brelect-bresinp::-webkit-input-placeholder {
  color: #a9a9a9;
}

.brelect-bresinp:-moz-placeholder {
  color: #a9a9a9;
}

.brelect-bresinp::-moz-placeholder {
  color: #a9a9a9;
}

.brelect-bresinp:-ms-input-placeholder {
  color: #a9a9a9;
}

.brelect-bconfirm {
  display: block;
  float: right;
  margin: 13px 15px 0 0;
  padding: 0;
  width: 48px;
  height: 32px;
  background: #f44d4d;
  border-radius: 3px;
  outline: none;
  color: #ffffff;
}

.brelect-bconfirm:hover,
.brelect-bconfirm:focus {
  background: #f44d4d;
  color: #ffffff;
}

.brelect-bempty {
  display: block;
  float: right;
  margin: 13px 15px 0 0;
  padding: 0;
  width: 48px;
  height: 32px;
  border: none;
  outline: none;
  color: #3184d9;
}

.brelect-bempty:hover,
.brelect-bempty:focus {
  background: none;
  color: #3184d9;
}

.brand-mark {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}

.brand-tooltip {
  display: none;
  position: fixed;
  top: 380px;
  left: 50%;
  margin-left: -150px;
  padding: 15px 50px 15px;
  max-width: 300px;
  line-height: 22px;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  box-shadow: 0px 0px 5px #fff;
  color: #fff;
  font-size: 14px;
  z-index: 10;
}

/* 问卷调查图片 */
.wjdc-img{
  width: 230px;
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 99;
}
</style>
